/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  deleteCall,
  fileUpload,
  get,
  riskProfile,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import {
  formatABN,
  formatMobile,
  formatName,
  formatPhone,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import { debounce } from "lodash";
import MainBody from "../../components/MainBody/MainBody";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../components/Pagination";
import sortCaret from "../../components/SortCaret";
// import SyncXero from "../../components/SyncXero";
import AddEditJointAccount from "./AddEditJointAccount";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { LucidePlusCircle } from "lucide-react";
import JointAccountActionButton from "./JointAccountActionButton";
import Confirmation from "../../components/Confirmation";
// import { useTrust } from "../../lib/context/TrustContext";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { AMLCTFModuleConditonIndustry } from "../../lib/PermissionConditions";
import { useUser } from "../../lib/context/UserContext";
import CommonFilters from "../../components/CommonFilters";
import ExpandContactTypeCDD from "../AML-CTF/CDD/ExpandContactTypeCDD";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import AdditionalDocumentEmailModal from "../../components/Email/AdditionalDocumentEmailModal";
import { Button } from "../../components/ui/button";
import DynamicTooltip from "../../components/DynamicToolTip";
import NameUpdate from "../AML-CTF/CDD/NameUpdate";

const JointAccounts = ({ org = false }) => {
  const { organizationData } = useOrganization();
  const { userData } = useUser();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [edit, setEdit] = useState(false);
  const [onlyKyc, setOnlyKyc] = useState(false);
  const [jointAccountsList, setJointAccountsList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [showSendEmail, setShowSendEmail] = useState(false);
  const [files, setFiles] = useState([]);
  const [mailData, setMailData] = useState(false);

  const params = useParams();
  const trustId = params?.trust_id;
  // const builderId = localStorage.getItem("builderId")
  //   ? localStorage.getItem("builderId")
  //   : "";

  // const [selectedRowIds, setSelectedRowIds] = useState([]);

  const [jointAccountId, setJointAccountId] = useState(null);
  const [showAddEditJointAccount, setShowAddEditJointAccount] = useState(false);
  const [showJointAccountDelete, setShowJointAccountDelete] = useState(false);
  const [amlCtfContactId, setAmlCtfContactId] = useState(org ? "1" : "");
  const [trustIds, setTrustIds] = useState();

  const handleSendEmail = async (id) => {
    if (showSendEmail) {
      setFiles([]);
    } else {
      if (id) {
        const { data } = await get(`${API.JOINT_ACCOUNT_DETAILS}/` + id);
        setMailData(data?.data);
      }
    }
    setShowSendEmail(!showSendEmail);
    setJointAccountId(id);
  };

  const handleSubmit = async (values) => {
    if (jointAccountId) {
      try {
        setLoading(true);
        const formData = new FormData();
        // formData.append("id", paymentId);
        formData.append("type", "joint-account-consent");
        formData.append("trust_id", trustId);

        for (const key in values) {
          if (key !== "ccChip" && key !== "bccChip") {
            if (key === "cc" || key === "bcc") {
              if (values[key]) {
                let valueData = values[key];
                for (
                  let valueIndex = 0;
                  valueIndex < valueData?.length;
                  valueIndex++
                ) {
                  formData.append(
                    `${key}[${valueIndex}]`,
                    valueData[valueIndex],
                  );
                }
              }
            } else {
              formData.append(key, values[key]);
            }
          }
        }
        files?.forEach((file, index) => {
          formData.append(`attachments[${index}]`, file);
        });
        await fileUpload(`${API.SEND_EMAIL_DOCS}/${jointAccountId}`, formData);
        setShowSendEmail(false);
        fetchJointAccount(limit, page);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const PostDefaultMail = useCallback(async (id, mailData) => {
    if (id) {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("type", "joint-account-consent");
        formData.append("trust_id", trustId);
        formData.append("to", mailData?.email ? [mailData?.email] : []);
        formData.append("subject", mailData?.subject ? mailData?.subject : "");
        await fileUpload(`${API.SEND_EMAIL_DOCS}/${id}`, formData);
        setShowSendEmail(false);
        fetchJointAccount(limit, page);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  const toggleShowAddEditJointAccount = () => {
    if (showAddEditJointAccount) {
      setEdit(false);
      setOnlyKyc(false);
      setJointAccountId(null);
      fetchJointAccount(limit, page);
    }
    setShowAddEditJointAccount(!showAddEditJointAccount);
  };

  const toggleShowDelete = () => {
    if (showJointAccountDelete) {
      setJointAccountId(null);
    }
    setShowJointAccountDelete(!showJointAccountDelete);
  };

  const fetchJointAccount = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          org
            ? `${API.GET_JOINT_ACCOUNTS}?limit=${
                passLimit ? passLimit : limit ? limit : defaultLimitPagination
              }&page=${passPage ? passPage : page ? page : 1}&search=${
                searchParam ? searchParam : ""
              }&sort_column=${sortField ? sortField : ""}&sort_order=${
                sortOrder ? sortOrder : ""
              }&trust_ids=${trustIds ? trustIds : organizationData?.organizationData?.trust_ids && organizationData?.organizationData?.trust_ids?.length > 0 ? organizationData?.organizationData?.trust_ids?.join(",") : ""}&organization_id=${
                organizationData?.organizationId
              }&is_aml_ctf=${amlCtfContactId ? amlCtfContactId : ""}`
            : `${API.GET_JOINT_ACCOUNTS}?limit=${
                passLimit ? passLimit : limit ? limit : defaultLimitPagination
              }&page=${passPage ? passPage : page ? page : 1}&search=${
                searchParam ? searchParam : ""
              }&sort_column=${sortField ? sortField : ""}&sort_order=${
                sortOrder ? sortOrder : ""
              }&trust_id=${trustId ? trustId : ""}`,
        );

        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const jointAccountsList = data.data.data;
        let notSelectedIds = [];
        for (let i = 0; i < jointAccountsList?.length; i++) {
          notSelectedIds.push(jointAccountsList[i]?.id);
        }
        // setNotSelectedRowIds(notSelectedIds);
        setJointAccountsList(jointAccountsList);
        return data.data;
      } catch (error) {
        setLoading(false);
        setJointAccountsList([]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      searchParam,
      sortOrder,
      sortField,
      trustId,
      trustIds,
      organizationData?.organizationId,
      amlCtfContactId,
    ],
  );

  const jointAccountsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      let risk = jointAccountsList[i]?.kyc?.risk
        ? riskProfile?.find(
            (item) => item.value == jointAccountsList[i]?.kyc?.risk,
          )
        : "";
      items.push({
        key: jointAccountsList[i]?.id,
        trust: jointAccountsList[i]?.trust
          ? formatSubcontractorName(jointAccountsList[i]?.trust)
          : "AML-CTF",
        code: jointAccountsList[i]?.code ? jointAccountsList[i]?.code : "-",
        contact_name: formatSubcontractorName(
          jointAccountsList[i]?.contactable,
        ),
        contactable_type: jointAccountsList[i]?.contactable_type
          ? jointAccountsList[i]?.contactable_type === "vendor"
            ? getModuleNamingBySlug(
                organizationData?.organizationData,
                "vendors",
                "Vendor",
              )
            : jointAccountsList[i]?.contactable_type === "contact"
              ? getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "contacts",
                  "Customer",
                )
              : ""
          : "",
        name: (
          <div className="flex items-center gap-1 justify-between">
            {risk ? (
              <div className="flex items-center gap-1">
                <div
                  className={`rounded-full h-5 w-5 flex items-center justify-center text-white`}
                  style={{
                    background: risk.color,
                  }}
                >
                  {risk?.label?.charAt(0)}
                </div>
                {formatName(
                  jointAccountsList[i]?.first_name,
                  jointAccountsList[i]?.last_name,
                ) +
                  (jointAccountsList[i]?.business_name
                    ? ` (${jointAccountsList[i]?.business_name})`
                    : "")}
              </div>
            ) : (
              <div>
                {formatName(
                  jointAccountsList[i]?.first_name,
                  jointAccountsList[i]?.last_name,
                ) +
                  (jointAccountsList[i]?.business_name
                    ? ` (${jointAccountsList[i]?.business_name})`
                    : "")}
              </div>
            )}

            <NameUpdate
              contactData={{
                first_name: jointAccountsList[i]?.first_name
                  ? jointAccountsList[i]?.first_name
                  : "",
                last_name: jointAccountsList[i]?.last_name
                  ? jointAccountsList[i]?.last_name
                  : "",
                dob: jointAccountsList[i]?.dob ? jointAccountsList[i]?.dob : "",
                street: jointAccountsList[i]?.street
                  ? jointAccountsList[i]?.street
                  : "",
                suburb_id: jointAccountsList[i]?.suburb_id
                  ? jointAccountsList[i]?.suburb_id
                  : "",
                suburb: jointAccountsList[i]?.suburb?.name
                  ? jointAccountsList[i]?.suburb?.name
                  : "",
                state_id: jointAccountsList[i]?.state_id
                  ? jointAccountsList[i]?.state_id
                  : "",
                state: jointAccountsList[i]?.state?.short_name
                  ? jointAccountsList[i]?.state?.short_name
                  : "",
                postal_code: jointAccountsList[i]?.postal_code
                  ? jointAccountsList[i]?.postal_code
                  : "",
              }}
              kycData={{
                first_name: jointAccountsList[i]?.kyc?.match_details?.name
                  ?.first_name
                  ? jointAccountsList[i]?.kyc?.match_details?.name?.first_name
                  : "",
                last_name: jointAccountsList[i]?.kyc?.match_details?.name
                  ?.last_name
                  ? jointAccountsList[i]?.kyc?.match_details?.name?.last_name
                  : "",
                dob: jointAccountsList[i]?.kyc?.match_details?.date_of_birth
                  ? jointAccountsList[i]?.kyc?.match_details?.date_of_birth
                  : "",
                street: jointAccountsList[i]?.kyc?.match_details?.address
                  ?.street
                  ? jointAccountsList[i]?.kyc?.match_details?.address?.street
                  : "",
                suburb_id: jointAccountsList[i]?.kyc?.match_details?.address
                  ?.suburb_id
                  ? jointAccountsList[i]?.kyc?.match_details?.address?.suburb_id
                  : "",
                suburb: jointAccountsList[i]?.kyc?.match_details?.address
                  ?.suburb
                  ? jointAccountsList[i]?.kyc?.match_details?.address?.suburb
                  : "",
                state_id: jointAccountsList[i]?.kyc?.match_details?.address
                  ?.state_id
                  ? jointAccountsList[i]?.kyc?.match_details?.address?.state_id
                  : "",
                state: jointAccountsList[i]?.kyc?.match_details?.address?.state
                  ? jointAccountsList[i]?.kyc?.match_details?.address?.state
                  : "",
                postal_code: jointAccountsList[i]?.kyc?.match_details?.address
                  ?.post_code
                  ? jointAccountsList[i]?.kyc?.match_details?.address?.post_code
                  : "",
                match_details: jointAccountsList[i]?.kyc?.match_details
                  ? jointAccountsList[i]?.kyc?.match_details
                  : "",
              }}
              id={
                jointAccountsList[i]?.kyc?.id
                  ? jointAccountsList[i]?.kyc?.id
                  : ""
              }
              fetchData={() => fetchJointAccount(limit, page)}
              matchDetailsUpdated={
                jointAccountsList[i]?.kyc?.match_details_updated
              }
            />
          </div>
        ),
        email: jointAccountsList[i]?.email,
        abn: jointAccountsList[i]?.abn
          ? formatABN(jointAccountsList[i]?.abn)
          : "-",
        phone: jointAccountsList[i]?.phone
          ? formatPhone(jointAccountsList[i]?.phone)
          : "-",
        mobile: jointAccountsList[i]?.mobile
          ? formatMobile(jointAccountsList[i]?.mobile)
          : "-",
        business_name: jointAccountsList[i]?.business_name
          ? jointAccountsList[i]?.business_name
          : "-",
        source: jointAccountsList[i]?.import_from
          ? jointAccountsList[i]?.import_from
          : "TrustSoft",
        match_details: jointAccountsList[i]?.kyc?.match_details
          ? jointAccountsList[i]?.kyc?.match_details
          : "",
        match_details_updated: jointAccountsList[i]?.kyc?.match_details_updated
          ? jointAccountsList[i]?.kyc?.match_details_updated
          : "",
        kyc:
          jointAccountsList[i]?.type == 1
            ? jointAccountsList[i]?.kyc?.verifications?.length > 0
              ? [jointAccountsList[i]?.kyc]
              : []
            : jointAccountsList[i]?.type == 2 &&
                jointAccountsList[i]?.entity_type == 1
              ? [jointAccountsList[i]?.kyc]
              : [],
        action: (
          <>
            <JointAccountActionButton
              id={jointAccountsList[i]?.id}
              setEdit={setEdit}
              org={org}
              used={jointAccountsList[i]?.is_used ? true : false}
              setJointAccountId={setJointAccountId}
              toggleShowAddEditJointAccount={toggleShowAddEditJointAccount}
              toggleShowDelete={toggleShowDelete}
              setOnlyKyc={setOnlyKyc}
              trustId={trustId}
              jointAccount={jointAccountsList[i]}
              handleSendEmail={handleSendEmail}
              amlCTFEnable={amlCTFEnable}
            />
          </>
        ),
        kyc_action: (
          <JointAccountActionButton
            id={jointAccountsList[i]?.id}
            org={org}
            setEdit={setEdit}
            kycAction={true}
            setOnlyKyc={setOnlyKyc}
            setJointAccountId={setJointAccountId}
            toggleShowAddEditJointAccount={toggleShowAddEditJointAccount}
            trustId={trustId}
            jointAccount={jointAccountsList[i]}
            handleSendEmail={handleSendEmail}
            amlCTFEnable={amlCTFEnable}
          />
        ),
      });
    }
    return items;
  };

  const jointAccounts = jointAccountsGenerator(jointAccountsList?.length);

  let columns = org
    ? [
        {
          dataField: "trust",
          text: "Trust",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "contactable_type",
          text: "Type",
          sort: true,
          sortCaret,
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "contact_name",
          text: "Contact Name",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "code",
          text: "Code",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: `${THClasses} flex items-center min-h-[43px]`,
          classes: TDClasses,
          dataField: "name",
          text: (
            <div className="flex items-center">
              <p>Name</p>
              <DynamicTooltip
                className="text-white"
                content={
                  <div className="flex flex-col gap-2">
                    {riskProfile?.map((item) => (
                      <div className="flex items-center gap-1">
                        <div
                          className={`rounded-full h-5 w-5 flex items-center justify-center text-white`}
                          style={{
                            background: item.color,
                          }}
                        >
                          {item?.label?.charAt(0)}
                        </div>
                        {item?.label}
                      </div>
                    ))}
                  </div>
                }
              />
            </div>
          ),
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "business_name",
          text: "Business Name",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "email",
          text: "Email",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "abn",
          text: "ABN",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "phone",
          text: "Phone No.",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "mobile",
          text: "Mobile No.",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "source",
          text: "Source",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ]
    : [
        {
          dataField: "contactable_type",
          text: "Type",
          sort: true,
          sortCaret,
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "contact_name",
          text: "Contact Name",
          sort: true,
          sortCaret,
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "code",
          text: "Code",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "name",
          text: "Name",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "business_name",
          text: "Business Name",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "email",
          text: "Email",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "abn",
          text: "ABN",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "phone",
          text: "Phone No.",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "mobile",
          text: "Mobile No.",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "source",
          text: "Source",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ];

  if (amlCTFEnable) {
    columns.push({
      dataField: "kyc_action",
      text: "Onboarding",
      align: "center",
      headerAlign: "center",
      // style: { width: "127px" },
      headerClasses: THClasses,
      classes: TDClasses,
    });
  }

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  useEffect(() => {
    navigate(
      `?limit=${limit ? limit : defaultLimitPagination}&page=${
        page ? page : 1
      }&search=${searchParam ? searchParam : ""}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      },
    );
  }, [navigate, limit, searchParam, page, sortField, sortOrder]);

  useEffect(() => {
    fetchJointAccount();
  }, [fetchJointAccount]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchJointAccount(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchJointAccount(limit, page);
  };

  // const arrayRemove = (arr, value) => {
  //   return arr.filter(function (ele) {
  //     return ele !== value;
  //   });
  // };

  // const mainSelectRow = {
  //   mode: "checkbox",
  //   clickToSelect: false,
  //   classes: TDClasses,
  //   selected: selectedRowIds,
  //   // nonSelectable: xeroData?.connection_status === 1 ? [] : notSelectedRowIds,
  //   onSelectAll: (row, isSelect) => {
  //     if (jointAccountsList?.length > 0) {
  //       if (row) {
  //         const ids =
  //           isSelect &&
  //           isSelect?.length > 0 &&
  //           isSelect?.map((item) => {
  //             return item?.key;
  //           });
  //         setSelectedRowIds(selectedRowIds ? selectedRowIds.concat(ids) : ids);
  //       } else {
  //         const removableData =
  //           isSelect &&
  //           isSelect?.length > 0 &&
  //           isSelect.map(function (data) {
  //             return data?.key;
  //           });
  //         setSelectedRowIds(
  //           selectedRowIds
  //             ? selectedRowIds.filter((item) => !removableData.includes(item))
  //             : [],
  //         );
  //       }
  //     }
  //   },
  //   onSelect: (row, isSelect) => {
  //     if (isSelect) {
  //       setSelectedRowIds((keys) => [...keys, row?.key]);
  //     } else {
  //       setSelectedRowIds(arrayRemove(selectedRowIds, row?.key));
  //     }
  //   },
  // };

  // Single Joint Account Delete
  const handleJointAccountDelete = async () => {
    try {
      setLoading(true);
      await deleteCall(`${API.JOINT_ACCOUNT_DELETE}/${jointAccountId}`);
      setLoading(false);
      fetchJointAccount(limit, page);
    } catch (error) {
      setLoading(false);
    }
  };

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandContactTypeCDD
          cddsList={row?.kyc}
          fetchCDDs={fetchJointAccount}
        />
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  return (
    <>
      <MainBody
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        actionContent={
          <div className="flex items-center gap-3 flex-wrap">
            {amlCTFEnable ? (
              <div className="flex items-center gap-2">
                Contact Data Mismatch:
                <DynamicTooltip
                  position="bottomRight"
                  content={
                    <div className="flex flex-col gap-2 w-[150px]">
                      <div className="flex items-center gap-1.5">
                        <div
                          className={`min-h-5 min-w-2 bg-red-500 dark:bg-red-500`}
                        />
                        Did Not Match
                      </div>
                      <div className="flex items-center gap-1.5">
                        <div
                          className={`min-h-5 min-w-2 bg-yellow-300 dark:bg-yellow-500`}
                        />
                        Updated as per the ID document.
                      </div>
                    </div>
                  }
                />
              </div>
            ) : (
              <></>
            )}
            {org && (
              <CommonFilters
                trust={org}
                trustId={trustIds}
                multiTrust={org}
                setTrustId={setTrustIds}
                aml_ctf_contact={true}
                amlCtfContactId={amlCtfContactId}
                setAmlCtfContactId={setAmlCtfContactId}
              />
            )}

            {/* Add JointAccount */}
            <ResponsiveDrawerForm
              description={""}
              title={
                onlyKyc
                  ? `JointAccount Onboarding`
                  : edit
                    ? "Edit JointAccount"
                    : "Add JointAccount"
              }
              handleOpen={() => {}}
              handleClose={() => {
                setEdit(false);
                setOnlyKyc(false);
                setJointAccountId(null);
                setShowAddEditJointAccount(false);
                fetchJointAccount(limit, page);
              }}
              write={true}
              buttonText={
                <div className="flex items-center gap-1">
                  <LucidePlusCircle size={18} />
                  <span>Add JointAccount</span>
                </div>
              }
              className={"overflow-y-hidden"}
              open={showAddEditJointAccount}
              buttonClassName={""}
              setOpen={setShowAddEditJointAccount}
            >
              <AddEditJointAccount
                edit={edit}
                toggleShowAddEditJointAccount={toggleShowAddEditJointAccount}
                id={jointAccountId}
                trustId={trustId}
                org={org}
                amlCTFEnable={amlCTFEnable}
                setEdit={setEdit}
                onlyKyc={onlyKyc}
                fetchJointAccountData={() => fetchJointAccount(limit, page)}
              />
            </ResponsiveDrawerForm>
          </div>
        }
        mainClassName="w-[calc(100%-3rem)]"
        loading={loading}
      >
        <div className="custom-table">
          <div className="table-body-class">
            {amlCTFEnable ? (
              <BootstrapTable
                keyField="key"
                remote
                data={jointAccounts}
                expandRow={expandRow}
                // selectRow={mainSelectRow}
                columns={columns}
                onTableChange={handleTableChange}
                rowClasses={(row) => {
                  if (row?.match_details) {
                    return `${TRClasses} contact-not-match`;
                  }
                  if (row?.match_details_updated) {
                    return `${TRClasses} contact-kyc-update`;
                  }
                  return TRClasses;
                }}
                noDataIndication="No Data Found"
                classes={TableClasses}
                wrapperClasses={TableWrapClasses}
              />
            ) : (
              <BootstrapTable
                keyField="key"
                remote
                data={jointAccounts}
                // selectRow={mainSelectRow}
                columns={columns}
                onTableChange={handleTableChange}
                rowClasses={TRClasses}
                noDataIndication="No Data Found"
                classes={TableClasses}
                wrapperClasses={TableWrapClasses}
              />
            )}
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />

          <ResponsiveDrawerForm
            description={""}
            title={"Send Email"}
            handleOpen={() => {}}
            handleClose={() => {}}
            className={"sm:max-w-[50vw] max:min-w-screen"}
            open={showSendEmail}
            buttonClassName={""}
            setOpen={setShowSendEmail}
            read={true}
            mobileCancelHidden={true}
          >
            <div className="overflow-y-auto overflow-x-hidden max-h-[78vh] md:p-0 p-4">
              <AdditionalDocumentEmailModal
                defaultAdditionalState={true}
                defaultContent={
                  <>
                    <div className="text-center">
                      Are you sure you want to email this consent to the contact
                      for the aml changes?
                    </div>
                    <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
                      <Button
                        type="submit"
                        onClick={() => {
                          jointAccountId &&
                            PostDefaultMail(jointAccountId, mailData);
                        }}
                      >
                        Yes
                      </Button>
                      <Button
                        type="Button"
                        className="ml-3"
                        variant="secondary"
                        onClick={() => {
                          handleSendEmail();
                        }}
                      >
                        No
                      </Button>
                    </div>
                  </>
                }
                handleSubmit={handleSubmit}
                setFiles={setFiles}
                files={files}
                toggleCancel={handleSendEmail}
                // handleEditorChange={handleEditorChange}
                // editorState={editorState}
                mailData={mailData}
                type={"contact-consent"}
                loading={loading}
              />
            </div>
          </ResponsiveDrawerForm>
        </div>
      </MainBody>

      <Confirmation
        title={"Delete JointAccount"}
        open={showJointAccountDelete}
        setOpen={setShowJointAccountDelete}
        toggleShow={() => {
          toggleShowDelete();
        }}
        className="sm:max-w-1/2"
        message={"Are you sure you want to delete joint account?"}
        okAction={async () => {
          handleJointAccountDelete();
          toggleShowDelete();
          // fetchJointAccount();
        }}
        cancelAction={() => {
          setJointAccountId(null);
          setShowJointAccountDelete(!showJointAccountDelete);
        }}
      />
    </>
  );
};

export default JointAccounts;
